import { trigger, transition, style, query, animate, group } from '@angular/animations';

// Lightweight route fade: opacity only, no transforms/filters to keep things snappy
export const routeAnimations = trigger('routeAnimations', [
  transition('* <=> *', [
    // Set both enter/leave to overlap in the same stacking context
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%'
      })
    ], { optional: true }),

    group([
      // Fade out current view quickly
      query(':leave', [
        style({ opacity: 1 }),
        animate('150ms ease-out', style({ opacity: 0 }))
      ], { optional: true }),

      // Fade in next view slightly after/simultaneously
      query(':enter', [
        style({ opacity: 0 }),
        animate('200ms ease-in', style({ opacity: 1 }))
      ], { optional: true })
    ])
  ])
]);